import React from "react";

import Review from "./Review.jsx";

const ReviewsList = ({reviews, loading}) => {

  return <div className={`ft_yotpo-review-list ${loading ? "loading" : ""}`}>
      {reviews.map((review) => <Review key={review.id} review={review} />)}
  </div>

}

export default ReviewsList;
